import { useState, type ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './AuthProvider';
import { createApplicationQueryClient } from './createApplicationQueryClient';
import { EnabledModulesProvider } from './EnabledModulesProvider';
import { HostWorkspaceProvider } from './HostWorkspaceProvider';

interface ApplicationProvidersProps {
  children: ReactNode;
}

export function ApplicationProviders({ children }: ApplicationProvidersProps) {
  const [queryClient] = useState(createApplicationQueryClient);

  return (
    <QueryClientProvider client={queryClient}>
      <HostWorkspaceProvider>
        <AuthProvider>
          <EnabledModulesProvider>
            <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              {children}
            </BrowserRouter>
          </EnabledModulesProvider>
        </AuthProvider>
      </HostWorkspaceProvider>
      <Toaster
        position="top-right"
        richColors
        closeButton
        toastOptions={{ classNames: { closeButton: '!w-6 !h-6' } }}
      />
    </QueryClientProvider>
  );
}
